import { __awaiter, __generator } from "tslib";
// services/data/tripCategoryLoader.ts
import { getTripCategories } from "../../services/api/EventCreationServices";
export var loadTripCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getTripCategories()];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res || []];
            case 2:
                error_1 = _a.sent();
                console.error("Error loading trip categories:", error_1);
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
